import { useToast } from '@chakra-ui/react';
import { useAcceptAccessControlInviteMutation } from '@client/graphql/__generated__/main-operations';
import { FC, useEffect } from 'react';
import { Navigate, useNavigate, useParams } from 'react-router';
import { useAppContext } from '~/services/main/contexts/AppContext';

export const InvitationAcceptPage: FC = () => {
  const { isAuthenticated } = useAppContext();
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();
  const toast = useToast();
  const [acceptInvite] = useAcceptAccessControlInviteMutation();

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    const acceptInvitation = async () => {
      const { data } = await acceptInvite({
        variables: { input: { code: code as string } },
      });

      if (
        data?.acceptAccessControlInvite?.targetEntityName === 'Listing' &&
        data?.acceptAccessControlInvite?.targetId
      ) {
        navigate(`/listings/${data.acceptAccessControlInvite.targetId}`);
        toast({
          title: 'Invitation as listing admin accepted',
          status: 'success',
        });

        return;
      }

      // Reload the page to get the latest user data / orgs
      window.location.href = '/';
    };

    void acceptInvitation();
  }, [acceptInvite, code, navigate, toast, isAuthenticated]);

  if (!isAuthenticated) {
    return (
      <Navigate
        to={`/auth/login?next=${window.location.pathname}&invitationCode=${code}`}
      />
    );
  }

  return null;
};
